import { render, staticRenderFns } from "./productBom.vue?vue&type=template&id=37c27586&scoped=true"
import script from "./productBom.vue?vue&type=script&lang=js"
export * from "./productBom.vue?vue&type=script&lang=js"
import style0 from "./productBom.vue?vue&type=style&index=0&id=37c27586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c27586",
  null
  
)

export default component.exports